import { ReactComponent } from 'ag-grid-react/lib/reactComponent'
import React from 'react'
import { Paperclip, Trash, } from 'react-feather'
import { ReactComponent as CameraIcon } from '../assets/img/svg/picture-icon.svg'
import { ReactComponent as FileIcon } from '../assets/img/svg/file-icon.svg'
import { ReactComponent as AudioIcon } from '../assets/img/svg/audio-icon.svg'
import { ReactComponent as VideoIcon } from '../assets/img/svg/video-icon.svg'
import { ReactComponent as ContactIcon } from '../assets/img/svg/contact-icon.svg'
import { ReactComponent as MegaphoneIcon } from '../assets/img/svg/megaphone.svg'
import { secondsToTime } from './timeLegend'

const fileIcon = (type, fileType, preview, dimensions, sizeBytes) => {
    switch (fileType) {
        //Vídeos
        case "video/x-msvideo":   
        case "video/mpeg":   
        case "video/ogg":   
        case "video/webm":   
        case "video/3gpp":   
        case "video/3gpp2":   
        case "video/quicktime":   
        case "video/x-flv":   
        case "video/mp4":   
        case "video/x-ms-wmv":   
        if(type === 'sendfile'){
          return {
            file: <video width={dimensions && dimensions.width} height={dimensions && dimensions.height} playsInline muted src={preview}></video>,
            type: "video",
            sizeBytes: sizeBytes
          }
        } else if(preview && preview.messageId){
          return {
            file: <video width={dimensions && dimensions.width} height={dimensions && dimensions.height} playsInline muted src={!preview.messageId ? preview.storageName : preview.url ? `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URI}/${preview.url}` : `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URI}/messageattachments/${preview.urlProperty ? `${preview.urlProperty}/` : ''}${preview.messageId}/download/${preview.storageName}`}></video>,
            type: "video",
            sizeBytes: sizeBytes
          }
        } else {
          return {
            file: <video width="auto" height="320" playsInline muted src={preview.storageName}></video>,
            type: "video",
            sizeBytes: sizeBytes
          }
        }
        //imagens
        case "image/bmp":   
        case "image/gif":   
        case "image/jpeg":   
        case "image/svg+xml":   
        case "image/tiff":   
        case "image/png":   
        case "image/webp":   
        ///api/v1/messageattachments/{messageId}/download/{storageName}
            if(type === 'sendfile'){
              return {
                file: <img className={fileType === 'image/webp' ? 'sticker' : 'image'} src={preview}  width={dimensions && dimensions.width} height={dimensions && dimensions.height} />,
                type: "image",
                sizeBytes: sizeBytes
              };
            }  else {
              const img = <img className={fileType === 'image/webp' ? 'sticker' : 'image'} src={!preview.messageId ? preview.storageName : preview.url ? `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URI}/${preview.url}` : `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URI}/messageattachments/${preview.urlProperty ? `${preview.urlProperty}/` : ''}${preview.messageId}/download/${preview.storageName}`} width={dimensions && dimensions.width} height={dimensions && dimensions.height} />
              //const img = <img src={!preview.messageId ? preview.storageName : preview.url ? `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URI}/${preview.url}` : `${preview.urlprocess.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URI}/messageattachments/${preview.urlProperty ? `${preview.urlProperty}/` : ''}${preview.messageId}/download/${preview.storageName}`} alt="image" width={dimensions && dimensions.width} height={dimensions && dimensions.height} />
              return {
                file: img,
                type: "image",
                sizeBytes: sizeBytes
              };
            }
        //Excel
        case "application/vnd.ms-excel": 
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": 
            return {
                file: <div className="mime-type excel"><span>xls</span></div>,
                type: "file",
                sizeBytes: sizeBytes
            };
        //Word
        case "application/msword": 
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document": 
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.template": 
          return {
            file: <div className="mime-type word"><span>doc</span></div>,
            type: "file",
            sizeBytes: sizeBytes
          }
        //Rich Text Format
        case "application/rtf": 
          return {
            file: <div className="mime-type rich-text"><span>rtf</span></div>,
            type: "file",
            sizeBytes: sizeBytes
          }
        //PowerPoint
        case "application/vnd.ms-powerpoint": 
        case "application/vnd.openxmlformats-officedocument.presentationml.presentation": 
        case "application/vnd.openxmlformats-officedocument.presentationml.template": 
        case "application/vnd.openxmlformats-officedocument.presentationml.slideshow": 
          return {
            file: <div className="mime-type power-point"><span>ppt</span></div>,
            type: "file",
            sizeBytes: sizeBytes
          }
        //Arquivos de áudio
        case "audio/aac": 
        case "audio/x-wav": 
        case "audio/wav": 
        case "audio/webm":
        case "audio/ogg":
        case "audio/oga":
        case "audio/mpeg":
          return {
            file: <div className="mime-type audio"><span>AUD</span></div>,
            type: "audio",
            sizeBytes: sizeBytes
          }
        //Arquivos de áudio
        case "application/xml": 
          return {
            file: <div className="mime-type xml"><span>xml</span></div>,
            type: "file",
            sizeBytes: sizeBytes
          }
        //Apple iWork
        case "application/vnd.apple.numbers": 
          return {
            file: <div className="mime-type numbers"><span>num</span></div>,
            type: "file",
            sizeBytes: sizeBytes
          }
        case "application/vnd.apple.pages": 
          return {
            file: <div className="mime-type pages"><span>pag</span></div>,
            type: "file",
            sizeBytes: sizeBytes
          }
        case "application/vnd.apple.keynote": 
          return {
            file: <div className="mime-type keynote"><span>key</span></div>,
            type: "file",
            sizeBytes: sizeBytes
          }
        case "application/x-tar": 
        case "application/x-rar-compressed": 
        case "application/x-7z-compressed": 
        case "application/zip": 
        case "application/x-bzip2": 
            return {
                file: <div className="mime-type zip"><span>zip</span></div>,
                type: "file",
                sizeBytes: sizeBytes
            }
        case "application/pdf":  
        return {
                file: <div className="mime-type pdf"><span>pdf</span></div>,
                type: "file",
                sizeBytes: sizeBytes
            }
        default:      
        return {
            file: <div className="mime-type file"><span>arq</span></div>,
            type: "file",
            sizeBytes: sizeBytes
        }
      }    
}

const getFileSize = (sizeBytes) => {
    if(sizeBytes.toString().length < 7){
      return Math.round(sizeBytes/1000)+' KB'
    } else {
      return (sizeBytes/1000000).toFixed(1)+' MB'
    }     
}

const lastMessageIcon = (attachment, message, isBroadcastList, isTemplate) => {
  const isBroadcast = isBroadcastList ? <MegaphoneIcon className="broadcast-message" width={15} height={15} /> : null
  if(attachment){
    switch (attachment.contentType.split('/')[0]) {
      case 'image':
        return (<div className="d-flex align-items-center last-message-icon">{isBroadcast ? isBroadcast : <CameraIcon height="15" width="15" />} <span className="truncate">{message ? message : 'Foto'}</span></div>)
        break;
      case 'audio':
        return (<div className="d-flex align-items-center last-message-icon">{isBroadcast ? isBroadcast : <AudioIcon height="15" width="15" />} {secondsToTime(attachment.secondsAudio)}</div>)
        // expected output: "Mangoes and papayas are $2.79 a pound."
        break;
      case 'video':
        return (<div className="d-flex align-items-center last-message-icon">{isBroadcast ? isBroadcast : <VideoIcon height="15" width="15" />} <span className="truncate">{message ? message : 'Video'}</span></div>)
        break;
      case '':
        return (<div className="d-flex align-items-center last-message-icon">{isBroadcast ? isBroadcast : <FileIcon height="15" width="15" />} <span className="truncate">{message ? message : 'Arquivo ou documento'}</span></div>)
        // expected output: "Mangoes and papayas are $2.79 a pound."
        break;
      default:
        return (<div className="d-flex align-items-center last-message-icon">{isBroadcast ? isBroadcast :<FileIcon height="15" width="15" />} <span className="truncate">{message ? message : attachment.fileName}</span></div>)
    }
  } else if(!message && isTemplate){
    return <div>Template</div> 
  } else {
    return message && message.length === 0 ? 
      <div className="d-flex align-items-center">{isBroadcast ? isBroadcast : <Trash size={12} />} Mensagem apagada</div> : 
      <div className="d-flex align-items-center">{isBroadcast ? isBroadcast : null} {message}</div>
  }
}

const lastMessageVcard = (contact, isBroadcastList) => {
  const isBroadcast = isBroadcastList ? <MegaphoneIcon className="broadcast-message" width={15} height={15} /> : null
  return (
    <div className="d-flex align-items-center last-message-icon">{isBroadcast ? isBroadcast : <ContactIcon height="15" width="15" />} <span className="truncate">{contact}</span></div>
  )
}

export {
    fileIcon,
    getFileSize,
    lastMessageIcon,
    lastMessageVcard
}